import { getIsDesktop } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { ReactNode, memo } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { IQuickFactContent } from '@bridebook/toolbox/src/seo-facets/search-widgets';
import { SearchType } from '@bridebook/toolbox/src/search-suppliers/types';
import { ILocationData } from '@bridebook/web/app-shared/lib/search/types';
import QuickFactsItem from './quick-facts-item';

interface IProps {
  quickFacts: IQuickFactContent[];
  locationData?: ILocationData | null;
}

const QuickFacts = ({ quickFacts, locationData }: IProps) => {
  const { t } = useTranslation('search');
  const isDesktop = useSelector(getIsDesktop);

  if (!locationData || !quickFacts) {
    return null;
  }

  const firstRow = quickFacts.slice(0, 4);
  const secondRow = quickFacts.slice(4);

  const renderRow = (items: IQuickFactContent[], offset: number): ReactNode =>
    items.length > 0 ? (
      <div className="bsqf-list">
        {items.map((item, i) => (
          <div className="bsqf-col" key={i}>
            <QuickFactsItem item={item} index={i + offset} />
          </div>
        ))}
      </div>
    ) : null;

  const firstRowItems = renderRow(firstRow, 0);
  const secondRowItems = renderRow(secondRow, 4);

  const location =
    locationData.type === SearchType.County
      ? locationData.county || locationData.country
      : locationData.town || locationData.name;

  return (
    <div className="bsqf">
      <h2 className="bsqf-title">{t('quickFacts.title', { location })}</h2>
      {isDesktop || secondRow.length == 0 ? (
        <div className="bsqf-rows">
          {firstRowItems}
          {secondRowItems}
        </div>
      ) : (
        <AliceCarousel
          disableButtonsControls
          mouseTracking
          items={[firstRowItems, secondRowItems]}
        />
      )}
    </div>
  );
};

export default memo(QuickFacts);
